import { useMemo } from 'react';
import { Box, Text } from '@nimbus-ds/components';
import { CurrencyType } from '@tiendanube/common';
import { CancelAndConfirmButtons, CurrencyPrice } from 'commons/components';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';
import { ProductSearcherFooterProps } from '../ProductSearcher';

interface ProductSearcherConfirmProps {
  footerProps: ProductSearcherFooterProps<false>;
  currencyDisplay?: CurrencyType;
}

export function ProductSearcherConfirm({
  footerProps,
  currencyDisplay,
}: Readonly<ProductSearcherConfirmProps>) {
  const t = useTranslationOrders();

  const totalSelected = footerProps.selectedProducts.length;
  const totalPrice = useMemo(
    () =>
      footerProps.selectedProducts.reduce((acc, curr) => acc + curr.price, 0),
    [footerProps.selectedProducts],
  );

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      width="100%"
    >
      <Box display="flex" flexDirection="column" justifyContent="space-between">
        <Text>
          {t('productSearcher.searcherConfirm.selectedProductsCount', {
            count: totalSelected,
          })}
        </Text>
        <CurrencyPrice
          price={totalPrice}
          currency={currencyDisplay}
          bold
          appearance="light"
          size="highlight"
        />
      </Box>

      <Box display="flex" alignItems="center">
        <CancelAndConfirmButtons
          onCancel={footerProps.onClose}
          onConfirm={footerProps.onSubmit}
          confirmText={t('productSearcher.searcherConfirm.addConfirm')}
        />
      </Box>
    </Box>
  );
}
